import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormView } from '@form/cer-form-view';
import { CerFormViewSet } from '@form/cer-form-view-set';

export class UserApprovalDelegationForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet): void {
    viewSet.viewAdd(this.getView())
  }

  private getView() : CerFormView {
    var v = new CerFormView();

    v.viewMetadata = {
      name: 'user-approval-delegation', dataApiName: 'UserApprovalDelegation', text: 'Godkendelse, stedfortrædere', textSingular: 'Godkendelse, stedfortræder',
      primaryKey: 'id', baseFields: ['id', 'history']
    };

    v.fieldMetadata =
      [
        { name: 'user', text: 'Godkender', required: true, orderBy: 'Ascending', orderByPriority: 1,
          foreignKeyTableName: 'User', foreignKeyField: 'id', foreignKeyValue: 'shortName' },
        { name: 'userDelegatee', text: 'Stedfortræder', required: true, orderBy: 'Ascending', orderByPriority: 2,
          foreignKeyTableName: 'User', foreignKeyField: 'id', foreignKeyValue: 'shortName' },
        { name: 'isActive', text: 'Aktiv', format: 'CheckBox', defaultValue: true },
        { name: 'fromDate', text: 'Fra dato', format: 'DateShort' },
        { name: 'toDate', text: 'Til dato', format: 'DateShort' },
        { name: 'reason', text: 'Årsag', format: 'Text', validationMaxLen: 40, required: true }
      ];

      return v;
  }
}